import { Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import ForgetPasswordImage from "../../../styles/img/forgot-password-image.png";
import { CloseIcon } from "../../../styles/img/svg/CloseIcon";
import { UiPopup } from "../../_uiComponents/common/UiModal";
import { SuccussIcon } from "../../../styles/img/svg/SuccussIcon";
import { UiTab } from "../../_uiComponents/common/UiTab";
import { TabPanel } from "@mui/lab";
import { ForgotUsernameForm } from "./Forms/ForgotUsernameForm";
import { useTranslation } from "react-i18next";
import { SomethingWrongModal } from "../../_uiComponents/Popups/SomethingWrongModal";
import { ConfirmationIcon } from "../../../styles/img/svg/ConfirmationIcon";
import { UiButton } from "../../_uiComponents/common/UiButton";
import { useNavigate } from "react-router-dom";
import { ForgotPasswordForm } from "../auth/Forms/ForgotPasswordForm";
import { TRANSLATION_CONST } from "../../../_redux/_constants";
import { ForgotUserNameLeavePopup } from "./popups/forgotUserNameLeavePopup";
import { setForgotUsernameMessage } from "../../../_redux/_actions";
import { BackIcon } from "../../../styles/img/svg/BackIcon";

const validateSchema = () =>
  yup.object().shape({
    displayName: yup.string().required("displayName is required."),
  });

export const ForgotUsername = (props) => {
  const [showLeavingPopup, setShowLeavingPopup] = useState(false);
  const [formDirty, setFormDirty] = useState(false);
  const [passwordResetStep, setPasswordResetStep] = useState(1);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const showMessage = auth?.forgotMessageShown ?? false;

  const handleShowMessage = () => {
    dispatch(setForgotUsernameMessage());
  };

  const goToHome = () => {
    if (formDirty) {
      setShowLeavingPopup(true);
    } else {
      navigate("/");
    }
  };

  const okBtnHandler = () => {
    navigate("/");
  };

  const tabList = [
    {
      id: 1,
      label: t("Password"),
      value: "1",
    },
    {
      id: 2,
      label: t("Username"),
      value: "2",
    },
  ];

  const backToHome = () => {
    navigate("/");
  };

  return (
    <>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box df-onboard-nic-begin-tab">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__close-icon" onClick={goToHome}>
            <CloseIcon />
          </div>

          <div className="df-user-profile__back-icon" onClick={backToHome}>
            <BackIcon />
          </div>

          <div className="df-user-profile__body  df-pw-tab ">
            <UiTab tabNav={tabList} className="df-db-tab-wrapper">
              <TabPanel value="1">
                <Grid container>
                  <Grid
                    size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                    className="text-center"
                  >
                    <h2 className="df-reset-pw-title">
                      {t("Reset your username or password here.")}
                    </h2>

                    <img
                      src={ForgetPasswordImage}
                      className="df-reset-pw-img df-forgot-pw-img"
                    />
                  </Grid>

                  <Grid
                    size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                    className="text-right df-pl-2"
                  >
                    <ForgotPasswordForm onDirtyChange={setFormDirty} />
                  </Grid>
                </Grid>
              </TabPanel>

              <TabPanel value="2" className="df-card-tab">
                <Grid container>
                  <Grid
                    size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                    className="text-center"
                  >
                    <h2 className="df-reset-pw-title">
                      {t("Reset your username or password here.")}
                    </h2>
                    <img
                      src={ForgetPasswordImage}
                      className="df-reset-pw-img df-onboard-side-img"
                    />
                  </Grid>

                  <Grid
                    size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                    className="text-right df-pl-2"
                  >
                    <ForgotUsernameForm onDirtyChange={setFormDirty} />
                  </Grid>
                </Grid>
              </TabPanel>
            </UiTab>
          </div>
        </Container>
      </div>

      {showMessage ? (
        <UiPopup openModal={showMessage} handleClose={handleShowMessage}>
          <SomethingWrongModal
            icon={<ConfirmationIcon />}
            buttonText={t("Ok")}
            buttonOnClick={handleShowMessage}
            className="df-confirmation-message-popup df-btn-grpdmodal"
            buttonClass="df-ui-dark-bg-btn df-w-90-btn"
          >
            <p>
              {t(
                "Reset your password using the self-reset option or self-recover your username.",
              )}
            </p>

            <p className="mb-0  mt-1">
              If you prefer assistance from the bank to reset your password,
              {i18n.language === TRANSLATION_CONST?.ENGLISH.lan ? (
                <>{t("please contact")}</>
              ) : (
                <>
                  {" "}
                  <br />
                  <a
                    href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
                    className="df-primary-underlined-btn  mt-0 mb-0 df-link-color"
                  >
                    {t("please contact")}
                  </a>
                </>
              )}
              {` `}
              {i18n.language === TRANSLATION_CONST?.ENGLISH.lan && (
                <a
                  href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
                  className="df-primary-underlined-btn  mt-0 mb-0 df-link-color"
                >
                  {process.env.SUPPORT_CENTER_CONTACT_NUMBER}
                </a>
              )}
            </p>
          </SomethingWrongModal>
        </UiPopup>
      ) : null}

      <UiPopup
        openModal={showLeavingPopup}
        handleClose={() => {
          setShowLeavingPopup(false);
        }}
      >
        <ForgotUserNameLeavePopup
          icon={<ConfirmationIcon />}
          message={t("Leaving this page?")}
          buttonText={t("Leave")}
          buttonOnClickClose={() => {
            setShowLeavingPopup(false);
          }}
          buttonOnClick={okBtnHandler}
          className="df-confirmation-message-popup df-btn-grpdmodal"
        >
          <p>
            {t(
              "Are you sure you want to leave this page? You have some unsaved changes.",
            )}
          </p>
        </ForgotUserNameLeavePopup>
      </UiPopup>
    </>
  );
};
